import React from 'react';
import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import ViewModuleOutlinedIcon from '@mui/icons-material/ViewModuleOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import { useNavigate } from 'react-router-dom';

/**
 * WhatsApp entry: choose Templates (placeholder) or Bulk messages (filters + flow).
 */
export function CommunicationWhatsAppHub() {
  const navigate = useNavigate();

  return (
    <Box sx={{ width: '100%', marginTop: '65px', padding: '27px' }}>
      <Typography sx={{ color: 'var(--Pallate-green-500, #288d2c)', fontFamily: 'inter', fontSize: '24px', fontWeight: 500, mb: 4 }}>
        WhatsApp communication
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, maxWidth: 900 }}>
        <Card
          sx={{
            width: 320,
            borderRadius: 2,
            border: '1px solid #E2E8F0',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}
        >
          <CardActionArea
            onClick={() => navigate('/communication/whatsapp/templates')}
            sx={{ alignItems: 'stretch', height: '100%' }}
          >
            <CardContent sx={{ p: 3 }}>
              <ViewModuleOutlinedIcon sx={{ fontSize: 40, color: '#288d2c', mb: 1.5 }} />
              <Typography sx={{ fontFamily: 'inter', fontSize: '18px', fontWeight: 600, color: '#1E293B', mb: 0.5 }}>
                Templates
              </Typography>
              <Typography sx={{ fontFamily: 'inter', fontSize: '14px', color: '#64748B', lineHeight: 1.5 }}>
                Manage and use message templates (coming soon).
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>

        <Card
          sx={{
            width: 320,
            borderRadius: 2,
            border: '1px solid #E2E8F0',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}
        >
          <CardActionArea onClick={() => navigate('/communication/whatsapp/bulk')} sx={{ alignItems: 'stretch', height: '100%' }}>
            <CardContent sx={{ p: 3 }}>
              <ForumOutlinedIcon sx={{ fontSize: 40, color: '#288d2c', mb: 1.5 }} />
              <Typography sx={{ fontFamily: 'inter', fontSize: '18px', fontWeight: 600, color: '#1E293B', mb: 0.5 }}>
                Bulk messages
              </Typography>
              <Typography sx={{ fontFamily: 'inter', fontSize: '14px', color: '#64748B', lineHeight: 1.5 }}>
                Apply member filters and send a bulk WhatsApp campaign.
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Box>
    </Box>
  );
}

export default CommunicationWhatsAppHub;
